import React from 'react';
import { Col, Row, Label, CardBody } from 'reactstrap';
import { api } from '../../../config';
import { convertToDisplayDateFormatddmmmyyyy } from '../../../utils/dateformatter';
import logger from '../../../utils/logger';
import { useState, useEffect } from 'react';

const IncotermTableFragment = ({ _incoTermTable = [], dataid, token }) => {
  const [qtyDeliveryDataIncoterm, setQtyDeliveryDataIncoterm] = useState({
    items: [],
  });

  useEffect(() => {
    const fetchDeliveryDataDetailIncoterm = async dataid => {
      // cek jika deliveryid belum tersedia
      try {
        const response = await fetch(
          `${api.API_URL}/quantity-incoterm?QuantityDeliveryTermId=${dataid}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();
        const items = result.data.items.map(item => ({
          incoterm: item.incoterm?.name ?? null,
          incotermPortType: item.incotermPortType,
          incotermLocation: item.incotermLocation?.name ?? null,
          startDate: convertToDisplayDateFormatddmmmyyyy(item.startDate),
          endDate: convertToDisplayDateFormatddmmmyyyy(item.endDate),
          incotermLocation2: item.incotermLocation2?.name ?? null,
          startDate2: convertToDisplayDateFormatddmmmyyyy(item.startDate2),
          endDate2: convertToDisplayDateFormatddmmmyyyy(item.endDate2),
          timelineType: item.timelineType,
        }));
        setQtyDeliveryDataIncoterm({ items });
      } catch (error) {
        logger.error('Error:', error);
      }
    };

    fetchDeliveryDataDetailIncoterm(dataid);
  }, [dataid, token]);

  return (
    <Col lg={7}>
      <Label for='incotermreadonly' className='form-label'>
        Incoterm
      </Label>
      <Row>
        <Col sm={12}>
          <div className='mb-2'>
            <CardBody>
              <div className='table-card overflow-x-auto'>
                <table
                  aria-label='Incoterm'
                  className='table table-hover table-centered align-middle table-nowrap '
                >
                  <thead className='table-light'>
                    <tr>
                      <th scope='col' width='100%' className=' py-1'>
                        Delivery
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {qtyDeliveryDataIncoterm.items.map((data, index) => (
                      <tr key={`${data.id}-${index}`}>
                        <td>
                          <p className='mb-1'>
                            {data.incoterm}
                            {'  '}
                            {data.incotermPortType}
                            {'  '}
                            {data.incotermLocation}
                            {',  '}
                            on{'  '}
                            {data.timelineType}
                            {'  '}
                            {data.startDate}
                            {' - '}
                            {data.endDate}
                          </p>

                          {data.incotermPortType === 'MultiPort' && (
                            <p className='mb-1'>
                              {data.incoterm}
                              {'  '}
                              {data.incotermPortType}
                              {'  '}
                              {data.incotermLocation2}
                              {',  '}
                              on{'  '}
                              {data.timelineType}
                              {'  '}
                              {data.startDate2}
                              {' - '}
                              {data.endDate2}
                            </p>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default IncotermTableFragment;
